

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import DataTable from "../DataTable.vue"

import User from "@/types/user"
import apiCaseNameSettings from "@/services/api_CaseNameSettings"
import { CaseNameSettings } from "@/types/caseNameSettings"

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"skeleton": SkeletonLoader
	}
})
export default class CaseNameSetup extends Vue {
	$refs!: {
		dataTable: DataTable
	}

	private loading: boolean = false;
	private caseNameSettings: CaseNameSettings[] = [];
	private caseNameReplacementListForDeletion: CaseNameSettings[] = [];
	private replacementCaseName: any = null;

	public async mounted () {
		await this.loadCaseNameSettings()
	}

	private get columns (): any[] {
		return [
			{ key: "title", label: "Title", sortable: true, errors: (item: any) => (item.title !== "") ? null : "Please enter a title" },
			{ key: "default", label: "Default", sortable: false, dataType: "checkbox" }
		]
	}

	private async loadCaseNameSettings () {
		this.loading = true
		this.caseNameSettings = await apiCaseNameSettings.caseNameSettingsList()
		this.loading = false
	}

	private createCaseNameSettings () {
		return { id: null, title: "", default: false }
	}

	private async saveCaseNameSettings (caseNameSettings: CaseNameSettings) {
		const currentCaseNameSetting = this.caseNameSettings.find(s => s.id === caseNameSettings.id)
		const currentCaseNameSettingWithDefault = this.caseNameSettings.find(s => s.default)

		// Add / update
		if (caseNameSettings.id === null || (currentCaseNameSetting && currentCaseNameSetting.title !== caseNameSettings.title)) {
			caseNameSettings.id = await apiCaseNameSettings.caseNameSettingsSave(caseNameSettings)
		}

		// Default
		if (caseNameSettings.default && caseNameSettings.id) {
			if ((currentCaseNameSettingWithDefault && currentCaseNameSettingWithDefault.id !== caseNameSettings.id) || currentCaseNameSettingWithDefault == null) {
				await apiCaseNameSettings.caseNameSettingsDefault(caseNameSettings)
			}
		}

		this.loadCaseNameSettings()
	}

	private async deleteCaseNameSetting (caseNameSettings: CaseNameSettings) {
		if (caseNameSettings.default === false && this.caseNameSettings.length > 1) {
			this.loading = true

			await apiCaseNameSettings.caseNameSettingsDelete(caseNameSettings)

			this.loadCaseNameSettings()
		}
	}
}
